import React, { Component } from "react";
import BacktestService from "../../../../service/backtest.service";
import alasql from "alasql";
import moment from "moment";
import DrillDownHolder from "../Rebalance/section1/drillDownHolder";
import DataTable from "../Datatable/DataTable";
import CompareHelper from "./compare.helper";
import WithCard from "../../../common/withCard";
import {
  Image as IMG,
  View,
  Document,
  Page,
  Text,
  pdf
} from "@react-pdf/renderer";
import PdfHeader from "../../../parts/pdfmaker/common/pdfHeader";
import PdfTable from "../../../parts/pdfmaker/common/pdfTable-BuySell";
import PDFHelper from "../../../parts/pdfmaker/pdf.helper";

class CompareOrig extends Component {
  state = {
    lastLivePort: [],
    lastCurrPort_orig: [],
    getBacktest_orig: [],
    // tables
    heading: [{ title: "Symbol" }, { title: "Weight" }],
    Table1: [],
    Table_orig: [],
    mergedTableHeading: [
      { title: "ORIGINAL Portfolio" },
      { title: "Weight" },
      { title: "IQCIO Portfolio" },
      { title: "Weight" },
      { title: "Action" }
    ],
    mergedTableData: [],
    mergeTableDataNoTag: []
  };

  async componentDidMount() {
    const live = this.props.getBacktest.getPortfolioData;
    const { origOBJ } = this.props;

    await BacktestService.getBacktest(
      `${origOBJ["scenario_id"]}`,
      `${origOBJ["benchmark"]}`,
      `${origOBJ["type"]}`
    ).then(res => {
      if (res) {
        this.setState({
          getBacktest_orig: res
        });
      }
    });

    const portfolioData_orig = this.state.getBacktest_orig.getPortfolioData;

    if (
      live &&
      live !== undefined &&
      live.length &&
      portfolioData_orig.length
    ) {
      let lastLiveDate = alasql("SELECT dt FROM ? ORDER BY dt DESC LIMIT 1", [
        live
      ]);
      let lastCurrDate = alasql("SELECT dt FROM ? ORDER BY dt DESC LIMIT 1", [
        portfolioData_orig
      ]);
      if (lastLiveDate.length !== 0) {
        var lastLivePort = alasql(
          "SELECT * FROM ? WHERE dt = '" + lastLiveDate[0].dt + "'",
          [live]
        );
      }
      if (lastCurrDate.length !== 0) {
        var lastCurrPort_orig = alasql(
          "SELECT * FROM ? WHERE dt = '" + lastCurrDate[0].dt + "'",
          [portfolioData_orig]
        );
      }

      // get recent Date data
      const getRecentData = data => {
        if (data) {
          var recentDate = moment(
            Math.max.apply(
              null,
              data.map(e => {
                return moment(e.dt);
              })
            )
          ).format("YYYY-MM-DD");

          let formatedDate = moment(recentDate).format("YYYY-MM-DD");

          var filteredObj = data.filter(function(e) {
            return e.dt === `${formatedDate}`;
          });
          return filteredObj;
        }
      };

      if (portfolioData_orig.length && live.length) {
        var data1 = getRecentData(portfolioData_orig);
        var data2 = getRecentData(live);
      }
      const mergedTableData = CompareHelper.compareOrigAndIqcio(data1, data2);

      // without bootstrap pill button data for pdf
      const mergeTableDataNoTag = CompareHelper.compareOrigAndIqcio_withoutTag(
        data1,
        data2
      );
      this.setState({
        lastLivePort,
        lastCurrPort_orig,
        mergedTableData,
        mergeTableDataNoTag
      });
    }
  }

  exportPDF2 = e => {
    Promise.all([
      PDFHelper.svgToPng("Compareorig1"),
      PDFHelper.svgToPng("Compareorig2")
    ]).then(values => {
      const MyDoc = () => (
        <Document>
          <Page size="A4" wrap>
            <PdfHeader
              mainHeading={
                this.props.getBacktest.getPortfolioMetrics[0]["scenario_name"]
              }
              // subHeading={
              //   this.props.getBacktest.getPortfolioMetrics[0]["scenario_id"]
              // }
              greyHeading={false}
            />
            <View style={{ paddingHorizontal: 35 }}>
              <View style={{ display: "flex", flexDirection: "row" }}>
                <View style={{ width: "50%" }}>
                  <View
                    style={{
                      color: "#223279",
                      paddingTop: 5,
                      textAlign: "center"
                    }}
                  >
                    <Text style={{ fontSize: 10 }}>ORIGINAL PORTFOLIO</Text>
                  </View>
                  <View>
                    <IMG source={values[0]}></IMG>
                  </View>
                </View>

                <View style={{ width: "50%" }}>
                  <View
                    style={{
                      color: "#223279",
                      paddingTop: 5,
                      textAlign: "center"
                    }}
                  >
                    <Text
                      style={{
                        fontSize: 10
                      }}
                    >
                      IQCIO OPTIMIZED
                    </Text>
                  </View>
                  <View>
                    <IMG source={values[1]} style={{ padding: 5 }}></IMG>
                  </View>
                </View>
              </View>
              <View style={{ paddingTop: 25 }}>
                <PdfTable
                  data={this.state.mergeTableDataNoTag}
                  heading={this.state.mergedTableHeading}
                />
              </View>
            </View>
          </Page>
        </Document>
      );
      // click action to generate pdf doc
      pdf(<MyDoc />)
        .toBlob()
        .then(blob => {
          const link = document.createElement("a");
          // create a blobURI pointing to our Blob
          link.href = URL.createObjectURL(blob);
          link.download = "sample.pdf";
          // some browser needs the anchor to be in the doc
          document.body.append(link);
          link.click();
          link.remove();
        });
    });
  };

  render() {
    const {
      mergedTableData,
      mergedTableHeading,
      lastLivePort,
      lastCurrPort_orig
    } = this.state;
    return (
      <div>
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <WithCard>
            <div style={{ display: "flex" }}>
              <button
                className="custom_btn"
                onClick={this.exportPDF2}
                style={{ marginLeft: "auto" }}
              >
                Download PDF{" "}
                <i className="fa fa-arrow-down bounce" aria-hidden="true"></i>
              </button>
            </div>
          </WithCard>
        </div>
        {lastLivePort.length ? (
          <DrillDownHolder
            lastLivePort={lastCurrPort_orig}
            lastCurrPort={lastLivePort}
            id1="Compareorig1"
            id2="Compareorig2"
            header1="Original Portfolio"
            header2="IQCIO Optimized"
          />
        ) : null}

        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <WithCard>
            {mergedTableData.length > 0 ? (
              <DataTable
                data={mergedTableData}
                columns={mergedTableHeading}
                paging={false}
                searching={false}
                scrollX={true}
              />
            ) : null}
          </WithCard>
        </div>
      </div>
    );
  }
}

export default CompareOrig;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/compareORIG/CompareOrig.jsx